var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isInvitation)?_c('div',_vm._b({style:(_vm.computedTextStyles)},'div',{ id: _vm.id },false),[_c('font-awesome-icon',{attrs:{"icon":"star"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }